import React from "react";
import TempleFeatures from "./TempleFeatures";

function Attract() {
  return (
    <div>
      <div className="row banner">
        <div className="bannerinside">
          <div className="headtitle">
            <div className="title-icon">
              <span className="icon-ring">
                <img src="./images/image.png" alt="Darshan" />
              </span>
            </div>

            <div className="title-content">
              <span className="title-small">TEMPLE</span>
              <h2 className="texthead">Attractions</h2>

              <div className="title-divider">
                <span></span>
                <i>✦</i>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-">
       
        <TempleFeatures />

        {/* <div className="row">
            <div className="col-md-6 border-bottom">
               <h1 className="attract-heading">Features of Maha Kshetram <br />(Great Temple)</h1>
               <p className="attract-text">
                    Other than the accepted spiritual and structural aspects, the following ten characteristics elevate the position of a temple to a Mahakshetram (Great Temple). They are antiquity, presence of records, historical importance, origin in a forest, nearness to an ocean, location at an elevation, royal connections, mention in ancient literatures, magnificence of architecture and grandeur of festivals. The Sree Padmanabhaswamy Temple qualifies all these characteristics.
               </p>
           </div> 
           <div className="col-md-6 border-bottom">
               <h1 className="attract-heading">Ananthasayanam Idol</h1>
               <p className="attract-text">
                    It is believed that twelve Salagramas stones, when worshipped together gain the potency of a Mahakshetram (Great Temple). The interior of the Katusarkara Idol of Sree Padmanabha Swamy is made up of twelve thousand and eight (12008) Salagramas collected from the bed of the river Gandaki in Nepal. Salagramas represent Sree Maha Vishnu. This Temple gains the greatness and sanctity of a thousand great temples.
               </p>
           </div> 
           <div className="col-md-6 border-bottom">
               <h1 className="attract-heading">Ottakkal Mandapam</h1>
               <p className="attract-text">
                    The Ottakkal Mandapam (single stone platform) in the Sree Padmanabhaswamy Temple is a striking feature. The Mandapam is in front of the sanctum sanctorum of Lord Sree Padmanabhaswamy. This structure is built with a single slab of granite which is two and a half feet thick and twenty feet square. The Abhishekams to Sree Padmanabhaswamy are performed in this Mandapam. Its granite pillars are covered with gold.
               </p>
           </div>
           <div className="col-md-6 border-bottom">
               <h1 className="attract-heading">The presence of Shiva</h1>
               <p className="attract-text">
                    The presence of Shiva within the Sreekovil adds significance to the sanctity of a Maha Kshetram dedicated to Vishnu. Many areas of the Temple are adorned with the images of Lord Shiva. As in many other Temples in Malayala Nadu, this Temple too stood free of cult clashes that often marred the face of orthodox religion in part of India. Siva’s presence is proof enough.
               </p>
           </div>
           <div className="col-md-6 border-bottom">
               <h1 className="attract-heading">Abhisravana Mandapam</h1>
               <p className="attract-text">
                    This structure is in front of the Ottakkal Mandapam but outside the Cherruchuttu containing the sanctum sanctorum. Special poojas related with Temple festivals are performed here. Devotees use this Mandapam for meditation and prayer.
               </p>
           </div>
           <div className="col-md-6 border-bottom">
               <h1 className="attract-heading">Kulasekhara Mandapam</h1>
               <p className="attract-text">
                   It is a marvelous and fantastic architectural work on stone. It is also known as Aayiramkaal Mandapam and Sapthaswara Mandapam. It is supported by 28 balustrades of pillars. The pillars on the four corners can produce musical notes when tapped. The pillars are adorned with exquisitely carved figures in half and full relief.
               </p>
           </div>
           <div className="col-md-6 border-bottom">
               <h1 className="attract-heading">The Golden flag-staff (Dwaja Stambham)</h1>
               <p className="attract-text">
                   An eighty feet high pole near the eastern corridor was installed by Anizham Tirunal. A teak wood of this dimension was carried from the nearby forest to the Temple. As per Sastras the wood should not touch the ground while in transport. The teak pole was then covered completely with gold foils. The apex of the flag pole has a figure of Garuda Swamy, in kneeling posture.</p>
           </div>
           <div className="col-md-6 border-bottom">
               <h1 className="attract-heading">Nine Entrances</h1>
               <p className="attract-text">
                   The Temple has nine entrances, indicating the nine orifices of the human body.</p>
           </div>
           <div className="col-md-6 border-bottom">
               <h1 className="attract-heading">Gopuram</h1>
               <p className="attract-text">
                   The Temple has a seven storeyed gopuram built on the eastern entrance. It is a fine example of South Indian architecture an is exclusively in Dravidian style. It is about 35 meters height. On the top there are 7 golden domes suggesting pointers to the seven Worlds. The 10 incarnations of Lord Vishnu are portrayed inside the first storey of the gopuram. The other three entrances are double storied Padippuras in typical Kerala Style. Entry to the upper levels of the Gopuram is restricted</p>
           </div>
           <div className="col-md-6 border-bottom">
               <h1 className="attract-heading">The Sreebalippura (Corridor)</h1>
               <p className="attract-text">
                   The Temple has a marvelous Sreebalippura. This magnificent rectangular corridor built of stone surrounds the main shrines and it is through this corridor that the Vahanams are taken out during Sreebali(procession). Records say that daily 4000 stone artisans, 6000 laborers and 100 elephants worked for a period of 6 months to finish the construction of the Sreebalippura. Sreebalippura is supported by 365 and a one quarter of pillars. Each pillar is a monolith. The master artisan Ananthapadmanabha Moothassari was in charge of the work.</p>
           </div>
           <div className="col-md-6 border-bottom">
               <h1 className="attract-heading">Theerthams (Sacred water resources)</h1>
               <p className="attract-text">
                   The Temple has a large number of sacred water resources situated even in places far away from the Temple. Of these, the main one Padmatheertham is located on the eastern side of the Temple. Padmatheertham is one of the oldest water bodies in the city of Thiruvananthapuram.</p>
           </div>
           <div className="col-md-6 border-bottom">
               <h1 className="attract-heading">Bells</h1>
               <p className="attract-text">
                   Large numbers of bells adorn the Temple. In most cases the tip of the bell has a metal banian leaf attached to its tongue.</p>
           </div>
           <div className="col-md-6 border-bottom">
               <h1 className="attract-heading">Multiplicity of Mandapams</h1>
               <p className="attract-text">
                   Another feature of this Temple is the multiplicity of Mandapams (platforms). There are 11 mandapams in the Temple and 8 in the Padmatheertham pond.</p>
           </div>
           <div className="col-md-6 border-bottom">
               <h1 className="attract-heading">Mural Paintings</h1>
               <p className="attract-text">
                   The outer walls of the sanctum sanctorum of Lord Padmanabha and Sree Krishna are adorned with murals. Of these, the Ananthasayanam on the backside of the sanctum is termed as the largest one among the temple murals of Kerala, and was painted by a Brahmin artist by name Chalayil Kalahasti. It is of 18 feet long.</p>
           </div>
            <div className="col-md-6 border-bottom">
               <h1 className="attract-heading">Thiruvambadi Sree Krishnaswamy Temple</h1>
               <p className="attract-text">
                   Even though the Thiruvambadi Sree Krishna Swamy Temple is inside the main Temple walls, it enjoys the status of a separate Temple with separate flag-staff, sacred stones and its own rites and rituals. It is quite unusual.</p>
           </div>
           
        </div> */}
        
        
      </div>
    </div>
  );
}

export default Attract;